import script from "./PaginatedListLinkField.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginatedListLinkField.vue?vue&type=script&lang=ts&setup=true"

import "./PaginatedListLinkField.vue?vue&type=style&index=0&id=93d278be&lang=scss"

const __exports__ = script;

export default __exports__